import { autoinject, computedFrom } from "aurelia-framework";
import { Router } from "aurelia-router";
import { MeasurementViewModel } from "../../models/measurement-view-model";
import { dispatchify, Store } from "aurelia-store";
import * as State from "../../store/state";
import IState = State.IState;
import { Subscription } from "rxjs";

@autoinject
export class WarningCard {
  warning: MeasurementViewModel;
	protected applicationState: IState;
	protected subscription: Subscription;
	protected store: Store<IState>;
	protected router: Router;

	constructor(store: Store<IState>, router: Router) {
		this.store = store;
		this.router = router;
	}
  bind(bindingContext: any, overrideContext: any) {
	  this.warning = bindingContext.warning;
		this.subscription = this.store.state.subscribe((state) => {
			this.applicationState = state;
		});
	}

	unbind() {
		this.subscription.unsubscribe();
	}

	@computedFrom("applicationState")
	get warningMessages() {
	return this.warning ? this.warning.warningMessages : null;
	}

	@computedFrom("applicationState")
	get header(): string {
		return this.warning ? `${this.warning.metadata.zoneName} > ${this.warning.metadata.structureName} > ${this.warning.metadata.deviceName }` : null;
	}

	@computedFrom("applicationState")
	get timestamp(): Date {
		return this.warning ? this.warning.data.timestamp : null ;
	}

	@computedFrom("applicationState")
	get statusColor(): string {
		return this.warning ? this.warning.deviceStyle : null;
	}

	navigateToDetails() {
		const device = this.warning.metadata;
		this.router.navigateToRoute("structure-detail", {locationId: device.locationId, zoneId: device.zoneId, structureId: device.structureId});
	}

	pauseNotifications(event: any) {
		event.stopPropagation();
	}
}
